<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="头像" prop="avatar">
        <a-upload
          :customRequest="fileUploadRequest"
          list-type="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange">
          <img v-if="form.avatar" :src="form.avatar" alt="图片" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">支持JPG、PNG图片文件 </span>
      </a-form-model-item>
      <a-form-model-item label="姓名" prop="name" >
        <a-input v-model="form.nickname" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="wxCode" >
        <a-input v-model="form.email" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="身份证号" prop="wxCode" >
        <a-input v-model="form.idCard" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="性别" prop="sex" >
        <a-select v-model="form.sex" placeholder="请选择">
          <a-select-option :value="0">未知</a-select-option>
          <a-select-option :value="1">男</a-select-option>
          <a-select-option :value="2">女</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="微信号" prop="wxCode" >
        <a-input v-model="form.wxCode" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="微信号图片" prop="wxCodeUrl" >
        <a-upload
          :customRequest="fileUploadRequest1"
          list-type="picture-card"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          @change="handleChange1">
          <img v-if="form.wxCodeUrl" :src="form.wxCodeUrl" alt="图片" style="height:104px;max-width:300px"/>
          <div v-else>
            <a-icon :type="uploadLoading1 ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <a-button type="primary" @click="handlePreview">预览</a-button>
        <br/>
        <span style="color:#ff0000">支持JPG、PNG图片文件 </span>
        <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage"/>
        </a-modal>
      </a-form-model-item>
      <a-form-model-item label="省" prop="province" >
        <a-input v-model="form.province" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="市" prop="city" >
        <a-input v-model="form.city" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="县" prop="county" >
        <a-input v-model="form.county" placeholder="请输入"/>
      </a-form-model-item>
      <a-form-model-item label="详细地址" prop="address" >
        <a-textarea :row="3" v-model="form.address" placeholder="请输入"/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getReferrals, updateReferrals } from '@/api/user/topReferrals'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading: false,
      uploadLoading1: false,
      type: 1,
      // 表单参数
      form: {
        id: null,
        nickname: null,
        avatar: null,
        type: null,
        mobile: null,
        email: null,
        idCard: null,
        sex: null,
        wxCode: null,
        wxCodeUrl: null,
        province: null,
        city: null,
        county: null,
        address: null
      },
      previewImage: null,
      previewVisible: false,
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        mobile: [
          { required: true, message: '手机号不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur'
          }
        ],
        nickname: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading = false
        this.form.avatar = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview() {
      this.previewImage = this.form.wxCodeUrl
      this.previewVisible = true
    },
    handleChange1(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading1 = true
        return
      }
      if (info.file.status === 'done') {
        this.uploadLoading1 = false
        this.form.wxCodeUrl = info.file.originFileObj.ossUrl
      }
    },
    fileUploadRequest1(fileInfo) {
      this.uploadLoading1 = true
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url
          fileInfo.file.ossUrl = ossUrl
          fileInfo.file.ossName = ossUrl
          fileInfo.onSuccess()
        }
      })
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if (file.size > 5 * 1024 * 1000) {
          this.$message.warning('图片大小不能超过5M')
          return reject(false)
        }

        var fileType = file.type
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片')
          return reject(false)
        }
        resolve(true)
      })
    },
    increase() {
      const that = this
      that.form.sort = that.form.sort + 1
    },
    validateNumber(event) {
      // 允许输入数字、小数点、负号
      // 同时设置了type="number"，所以还能防止非数字的输入
      event.target.value = event.target.value.replace(/[^0-9.]+/g, '')
      // 如果有小数点，只保留第一个
      const decimalIndex = event.target.value.indexOf('.')
      if (decimalIndex !== -1) {
        event.target.value = event.target.value.substr(0, decimalIndex) + '.' + event.target.value.substr(decimalIndex).replace(/\./g, '')
      }
      // 如果第一个字符是负号，保证只有当输入有数字时才允许负号
      if (event.target.value[0] === '-' && event.target.value.length > 1) {
        event.target.value = '-' + event.target.value.substr(1).replace(/[^0-9.]+/g, '')
      }
      // 更新数据
      this.form.sort = parseFloat(event.target.value)
    },
    decline() {
      const that = this
      that.form.sort = that.form.sort - 1
      if (that.form.sort < 0) {
        that.form.sort = 0
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        topName: null,
        isHot: null,
        cateName: null,
        createTime: null,
        sort: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getReferrals({ 'id': id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '专员信息'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          debugger
          this.submitLoading = true
          updateReferrals(this.form).then(response => {
            this.$message.success(
              '修改成功',
              3
            )
            this.open = false
            this.$emit('ok')
          }).finally(() => {
            this.submitLoading = false
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
